const ABORT_API_KEYS = {
  getLobby: 'getLobby',
  getGlobalLobby: 'getGlobalLobby',
  getCompetitionTable: 'getCompetitionTable'
};

export default ABORT_API_KEYS;
